export const AttendanceStatusOptions = [
  { label: 'Cancelado', value: 'CANCELLED' },
  { label: 'Aguardando atendimento', value: 'WAITING' },
  { label: 'Em atendimento', value: 'ON_GOING' },
  { label: 'Concluído', value: 'FINISHED' }];

export default AttendanceStatusOptions;
